// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Section-module--cls1--rV0GJ","cls2":"styles-Section-module--cls2--3K1eZ styles-Section-module--cls1--rV0GJ"};